import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function Icon({ Icon, color = '#c4c4c4', size, swapOpacity, spin, plus, flip, rotation, border, onClick, style = {}, className = '', type }) {
  return <FontAwesomeIcon type={type} className={className} onClick={onClick} icon={Icon} style={{ color: color, fontSize: size ? size : 16, ...style }} swapOpacity={swapOpacity} spin={spin} pulse={plus} flip={flip} rotation={rotation} border={border} />
}

export default Icon
